import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ApiConfiguration } from "src/app/services/http/api-configuration";
import { ApiService } from "src/app/services/http/api.service";
import { ToastClientService } from "src/app/services/toast/toast-client.service";
import { VisibilityModel } from "../models/visibility";

@Injectable({
  providedIn: "root",
})
export class VisibilityProvider {
  page = 1;
  getPaginationCount;
  visibility: VisibilityModel[] = [];
  configList = [];
  posmType: any[] = [];
  constructor(
    private apiService: ApiService,
    private toast: ToastClientService,
    private apiConfig: ApiConfiguration,
    private router: Router
  ) {
    this.posmType = [
      { id: 1, name: "Branding" },
      { id: 2, name: "Cooler" },
    ];
  }

  getVisibilityList(): void {
    this.apiService
      .getHeaders(this.apiConfig.getVisibilityList)
      .subscribe((res: any) => {
        this.visibility = res.body.data.posm_elements as VisibilityModel[];
      });
  }

  addVisibility(formdata): void {
    this.apiService.post(this.apiConfig.addVisibility, formdata).subscribe(
      (res: any) => {
        formdata.id = res.data.id;
        this.visibility.push(formdata);
        this.toast.Success(res.data.message);
        this.router.navigateByUrl("/hubAdmin/visibility-list");
      },
      (err) => {
        console.log(err);
      }
    );
  }

  editVisibility(formdata): void {
    this.apiService.post(this.apiConfig.editVisibility, formdata).subscribe(
      (res: any) => {
        let updateIndex = this.visibility.findIndex(
          (item) => item.id == formdata.id
        );
        this.visibility[updateIndex] = formdata;
        this.toast.Success(res.data.message);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  deleteVisibility(formdata): void {
    this.apiService.post(this.apiConfig.deleteVisibility, formdata).subscribe(
      (res: any) => {
        let updateIndex = this.visibility.findIndex(
          (item) => item.id == formdata.id
        );
        this.visibility.splice(updateIndex, 1);
        this.toast.Success(res.data.message);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  saveVisibilityConfigurations(formData) {
    this.apiService
      .post(this.apiConfig.saveVisibilityConfig, formData)
      .subscribe(
        (res: any) => {
          this.toast.Success(res.body.data.message);
        },
        (err) => {
          this.toast.Success(err.body.data.message);
        }
      );
  }

  getVisibilityConfigList() {
    this.apiService.get(this.apiConfig.getVisibilityConfig).subscribe(
      (res: any) => {
        this.configList = res.data.posm_master_config;
      },
      (err) => {
        console.log(err);
      }
    );
  }
}
